module.exports = __webpack_public_path__ + "static/7-bc1267bb57100377016deb298938b934.jpg";